import { useEffect, useState } from 'react';

export const useWipeInnerHtmlOnInit = (targetElements: Iterable<Element> | ArrayLike<Element>) => {
  const [isWipeComplete, setIsWipeComplete] = useState(false);
  const elementsArr = Array.from(targetElements);
  useEffect(() => {
    elementsArr.forEach((node) => (node.innerHTML = ''));
    setIsWipeComplete(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const output: [boolean, Element[]] = [isWipeComplete, elementsArr];
  return output;
};
